import React from "react";

export const DefaultTermsAndConditionEs = (
  <div style={{ paddingRight: "8px" }}>
    <div style={{ marginTop: " 8px" }}>
      <h2 style={{ textAlign: "center" }}>
        Términos y Condiciones de la Plataforma Nemuru
      </h2>
      <h3 style={{ marginTop: 0 }}>
        <strong>
          Por favor, lea atentamente estos términos y condiciones (los “T&C” o
          “Términos y Condiciones”) antes de aceptar los mismos o de utilizar la
          Plataforma o los Servicios de Nemuru.
        </strong>
      </h3>
    </div>
    <p>
      Estos Términos y Condiciones constituyen un acuerdo vinculante entre (i)
      Nemuru Digital, S.L. (en adelante,<span>&nbsp;</span>
      <strong>“Nemuru”</strong> o la<span>&nbsp;</span>
      <strong>“Compañía”</strong>), entidad constituida de conformidad con la
      legislación española, domiciliada en Edificio Palau de Mar, Plaza Pau
      Vila, número 1, 1ª planta, sector AD, oficina 1AD, Barcelona, provista de
      NIF B-67.183.574, inscrita en el Registro Mercantil de Barcelona, en el
      tomo 46.381, folio 118 y hoja B-518.127 y en el Registro Estatal de
      Intermediarios Financieros con el número 873/2018 de la sección 2ª; y (ii)
      el usuario que utiliza la Plataforma y/o se beneficia de los Servicios
      prestados por Nemuru (el <strong>“Usuario”</strong> y, conjuntamente con
      Nemuru, las <strong>“Partes”</strong>).
    </p>
    <p>
      Mediante la aceptación de estos T&C y el uso de la Plataforma de Nemuru,
      el Usuario manifiesta y garantiza a Nemuru (i) que los T&C los está
      formalizando o aceptando en su propio nombre y representación (en el caso
      de que sea una persona física) o en nombre y representación del Usuario
      (en el caso de que sea una persona jurídica), así como, en este último
      caso, que tiene capacidad suficiente para vincular y aceptar estos T&C en
      nombre y representación del Usuario; (ii) que es mayor de edad y tiene la
      capacidad legal suficiente para aceptar estos T&C (en el caso de que sea
      una persona física); y (iii) conocer y aceptar estos T&C, incluyendo la{" "}
      <a href="https://nemuru.com/privacidad-intermediacion" target="_blank">
        política de privacidad
      </a>{" "}
      (la<span>&nbsp;</span>
      <strong>"Política de Privacidad"</strong>) y la{" "}
      <a href="https://nemuru.com/cookies" target="_blank">
        política de cookies
      </a>{" "}
      (la
      <span>&nbsp;</span>
      <strong>"Política de Cookies"</strong>) de Nemuru, que se incorporan a
      estos T&C por referencia. Si no está de acuerdo o no desea aceptar los
      documentos anteriores, no debe acceder a la Plataforma ni beneficiarse de
      los Servicios prestados por Nemuru a través de la misma.
    </p>
    <ol>
      <li>
        <h3>
          <strong>Objeto</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Objeto: </strong>
            </h4>
            <span>
              El objeto de estos T&C es establecer los términos y condiciones
              que regirán el uso y los servicios prestados por Nemuru a través
              de la plataforma de Nemuru (la <strong>“Plataforma”</strong>),
              accesible a través de{" "}
              <a href="http://www.nemuru.com" target="_blank">
                www.nemuru.com
              </a>{" "}
              , así como de sus subdominios y/o directorios y/o aplicaciones
              móviles y/o cualquier otro dispositivo.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Validación</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Proceso de validación: </strong>
            </h4>
            <span>
              De forma previa a la formalización de estos T&C y durante la
              vigencia de los mismos, el Usuario deberá facilitar a Nemuru toda
              aquella documentación o información que se le solicite a los
              efectos de que Nemuru y, en su caso, cualquier tercero designado
              por Nemuru, puedan llevar a cabo un proceso de diligencia debida
              del Usuario, con el alcance que Nemuru considere oportuno o
              conveniente (el
              <span>&nbsp;</span>
              <strong>“Proceso de Validación“</strong>). Nemuru podrá facilitar
              a los correspondientes Prestamistas la información facilitada por
              el Usuario durante el Proceso de Validación, a los efectos de que,
              si corresponde, Nemuru o los Prestamistas puedan cumplir con sus
              obligaciones en materia de prevención del blanqueo de capitales y
              financiación del terrorismo o cualquier otra Legislación
              Aplicable. Asimismo, Nemuru podrá obtener información adicional
              relativa al Usuario de fuentes externas.
            </span>
          </li>
          <li>
            <h4>
              <strong>Registro: </strong>
            </h4>
            <span>
              Nemuru podrá requerir al Usuario que, para utilizar la Plataforma
              y cualquiera de las funcionalidades de la misma o de los Servicios
              prestados por Nemuru, el Usuario deba crea su propia cuenta
              personal (la<span>&nbsp;</span>
              <strong>"Cuenta"</strong>), para lo que deberá facilitar
              determinada información personal, que será tratada siempre de
              acuerdo con la Política de Privacidad de Nemuru. Dicha Cuenta será
              personal y sus datos de acceso estrictamente confidenciales, por
              lo que el Usuario será plenamente responsable de la actividad que
              se desarrolle en su Cuenta y Nemuru en ningún caso será
              responsable de las pérdidas o daños que el Usuario pueda sufrir
              como consecuencia de que otra persona utilice la Cuenta y/o acceda
              o utilice el contenido previsto en la misma. Del mismo modo, el
              Usuario será responsable de cualquier pérdida o daño causado por
              el uso de su Cuenta, independientemente de si está siendo
              utilizada por un tercero. Para mantener el control sobre la Cuenta
              y evitar que cualquier persona acceda a la misma, el Usuario
              deberá mantener el control sobre los dispositivos que se utilizan
              para acceder al servicio y no revelar a nadie la contraseña o los
              detalles del método de pago asociado a la Cuenta. El Usuario es
              responsable de actualizar y mantener la exactitud de la
              información que proporcione a Nemuru en relación con la Cuenta. Si
              se descubre o se tiene sospecha de cualquier uso no autorizado de
              la Cuenta, Nemuru puede cancelar o bloquear la misma frente al
              robo de identidad u otras actividades fraudulentas.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Servicios</strong>
        </h3>
        <ol>
          <li>
            <span>
              La finalidad de la Plataforma es ofrecer servicios de
              intermediación (los<span>&nbsp;</span>
              <strong>“Servicios”</strong>), que permitan al Usuario la
              posibilidad de optar a financiación (la<span>&nbsp;</span>
              <strong>“Financiación”</strong>), a conceder por parte de un
              prestamista independiente (el<span>&nbsp;</span>
              <strong>“Prestamistas”</strong>), para la compra de bienes o
              contratación de servicios a un profesional o empresa (los
              <span>&nbsp;</span>
              <strong>“Comercios”</strong>).
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Prestamistas y Proceso de Financiación</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Condiciones de Financiación: </strong>
            </h4>
            <span>
              El Prestamista que podrá conceder la Financiación y que se
              detallará en la propuesta será determinada en función de los
              acuerdos que Nemuru tuviera vigentes en cada momento. Las
              condiciones de la financiación a conceder por parte del
              Prestamista serán las facilitadas en cada momento y que se
              detallarán en la oferta de Financiación remitida al Usuario.
            </span>
          </li>
          <li>
            <h4>
              <strong>Propuesta de Préstamo: </strong>
            </h4>
            <span>
              Tras la revisión de la documentación o información facilitada, se
              llevará a cabo el Proceso de Validación, tanto por parte de Nemuru
              como del Prestamista que corresponda. En el supuesto en el que el
              Proceso de Validación sea satisfactorio, se remitirá al Usuario la
              propuesta u oferta de Financiación junto con la propuesta de
              préstamo (la<span>&nbsp;</span>
              <strong>“Propuesta de Préstamo”</strong>). En caso de que el
              Proceso de Validación no sea superado, se notificará dicha
              circunstancia y el Usuario no podrá optar a la Financiación. En
              todo caso, en el supuesto en el que se decida no conceder la
              Financiación, el Usuario no tendrá derecho a ningún tipo de
              compensación y ni Nemuru ni el Prestamista estarán obligados a
              conceder la Financiación ni abonar al Usuario ninguna cantidad
              como consecuencia de todo ello.
            </span>
            <p>
              A efectos aclaratorios, la aceptación de la solicitud de registro
              del Usuario o el envío de cualquier documentación por parte de
              Nemuru no conlleva, en ningún caso, la aceptación automática, por
              parte del Prestamista, de la oferta de financiación propuesta
              inicialmente.
            </p>
          </li>
          <li>
            <h4>
              <strong>Contrato de Préstamo: </strong>
            </h4>
            <span>
              Con carácter posterior a la conformidad de la Propuesta de
              Préstamo por parte del Prestamista, se pondrá a disposición del
              Usuario la información que corresponda de conformidad con la
              normativa aplicable. La mencionada información será puesta a
              disposición del Usuario por parte de Nemuru o del Prestamista,
              según hayan pactado previamente estas últimas. Con carácter
              posterior, el Prestamista y el Usuario suscribirán el contrato de
              préstamo (<strong>“Contrato de Préstamo”</strong>). El Contrato de
              Préstamo deberá ser firmado por el Usuario y el Prestamista a
              través del medio acordado entre Nemuru y el Prestamista. En todo
              caso, previsiblemente se formalizará:
            </span>
            <ul>
              <li>
                A través la Plataforma y mediante el sistema de firma
                electrónica que Nemuru pondrá a disposición del Usuario y del
                Prestamista
              </li>
              <li>
                A través de la plataforma electrónica que utilice el
                Prestamista.
              </li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Desembolso: </strong>
            </h4>
            <span>
              Una vez el Comercio haya comunicado el inicio de los servicios o
              la venta de los productos, y del mismo modo, el Usuario haya
              confirmado el inicio de los servicios y/o la compra de los
              productos, se firmará el Contrato de Préstamo y se abonará el
              importe del Préstamo en la cuenta titularidad del Comercio de
              conformidad con lo siguiente.
            </span>
            <p>
              Tras la formalización del Contrato de Préstamo, el Préstamo será
              desembolsado por el Prestamista en una cuenta abierta a nombre del
              Comercio o, en su caso, en una entidad de pago o en una entidad de
              dinero electrónico o en cualquier otra cuenta bancaria, todo ello
              de conformidad con las condiciones generales formalizadas entre el
              Comercio y Nemuru y en el correspondiente Contrato de Préstamo.
            </p>
          </li>
          <li>
            <h4>
              <strong>Oposición del Usuario: </strong>
            </h4>
            <span>
              En caso de que el Usuario tenga algún tipo de oposición en
              relación con el servicio prestado o al producto vendido por el
              Comercio, el Usuario deberá contactar con el Comercio a los
              efectos de trasladar dicha oposición y alcanzar un acuerdo, sin
              que Nemuru tenga ningún tipo de responsabilidad en relación con
              ello.
            </span>
            <p>
              Adicionalmente, en caso de que en el curso de la prestación de los
              servicios, el Usuario interpusiera una reclamación al Comercio por
              no estar de acuerdo con el resultado de los trabajos objeto de los
              servicios ya realizados alegando mala praxis o incumplimiento
              contractual por parte del Comercio y, en este sentido, lo
              notificara a Nemuru acompañando copia de la interposición de la
              preceptiva demanda judicial o reclamación en materia de consumo
              correspondiente, los fondos no transferidos al Comercio hasta la
              fecha quedarán retenidos, hasta que el Usuario y el Comercio
              notifiquen a Nemuru el acuerdo extrajudicial que, en su caso,
              hubieran alcanzado o bien hasta la resolución, laudo o sentencia
              judicial firme que se hubiera dictaminado respecto de la demanda o
              reclamación que hubiera interpuesto el Usuario al Comercio. En ese
              momento, Nemuru en base a lo acordado entre el Comercio y el
              Usuario o a lo dictaminado en la resolución, laudo o sentencia
              judicial firme correspondiente, procederá a ordenar la ejecución
              de la orden de transferencia que proceda, ya sea a favor del
              Comercio, si no se hubiera estimado la reclamación del Usuario, o
              bien a favor del Prestamista, si se hubiera estimado la
              reclamación del Usuario, para que en su caso aplique los fondos
              recibidos a la amortización total o parcial del Préstamo.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Derecho de Desistimiento</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>
                Ejercicio del derecho de desistimiento del Servicio prestado por
                Nemuru:{" "}
              </strong>
            </h4>
            <span>
              El Usuario tendrá derecho a ejercer su derecho de desistimiento
              respecto a los Servicios a prestar por Nemuru en el marco de estos
              T&C de conformidad con la normativa aplicable en cada momento.
            </span>
            <p>
              A tal efecto, el Usuario tiene un derecho de desistimiento en los
              catorce (14) días naturales siguientes a la formalización del
              contrato, sin alegación de causa alguna y sin penalización. Por
              tal motivo para ejercer el derecho de desistimiento se pone a
              disposición del Usuario en la Plataforma un formulario de
              desistimiento. El formulario es para solicitar el pedido de
              desistimiento de los servicios que realiza Nemuru como
              intermediario de la solicitud de préstamo o Financiación que está
              requiriendo el Usuario. El mismo tiene carácter formal, ya que es
              una declaración jurada de los datos y el pedido del Usuario.
              Importante a saber que el formulario en ningún caso es para
              finalizar ninguna relación con la entidad financiera o el
              Prestamista en el caso que el crédito esté concedido. En ese caso
              el proceso es diferente, el Usuario deberá contactar con Nemuru a
              través de los datos de contacto previstos en el presente
              documento.
            </p>
            <p>
              El Usuario exime a Nemuru de cualquier responsabilidad derivada de
              la utilización errónea del formulario de desistimiento en los
              términos indicados en la presente cláusula, renunciando a
              interponer reclamación alguna frente a Nemuru por ello.
            </p>
            <p>
              En todo caso, el uso del formulario de desistimiento no es
              obligatorio, ya que se puede desistir por cualquier medio admitido
              en derecho. Ante cualquier duda, el Usuario deberá contactar con
              Nemuru.
            </p>
          </li>
          <li>
            <h4>
              <strong>
                Ejercicio del derecho de desistimiento del Contrato de Préstamo:{" "}
              </strong>
            </h4>
            <span>
              Conforme a lo establecido en la normativa aplicable, el Usuario
              dispondrá de un plazo de catorce (14) días naturales para desistir
              del Contrato de Préstamo, comunicándolo al Prestamista por
              cualquier medio que permita dejar constancia sin indicación de los
              motivos ni penalización alguna. A efectos aclaratorios, se hace
              constar que el derecho a desistir del Contrato de Préstamo no
              implica, en modo alguno, el derecho a desistir del contrato de
              prestación de servicios que el Usuario hubiera suscrito con el
              Comercio o con Nemuru, que se regirá por su normativa específica.
            </span>
            <p>
              El Usuario eximen a Nemuru de cualquier responsabilidad derivada
              de la actuación de Nemuru en los términos indicados en la presente
              cláusula, renunciando a interponer reclamación alguna frente a
              Nemuru por ello.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Duración y Resolución</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Duración: </strong>
            </h4>
            <span>
              Estos T&C entrarán en vigor en la fecha de su formalización y
              tendrán una duración indefinida.
            </span>
          </li>
          <li>
            <h4>
              <strong>Resolución: </strong>
            </h4>
            <span>
              En todo caso las presentes T&C se resolverán y quedarán sin efecto
              en los siguientes supuesto:
            </span>
            <ul>
              <li>
                Por mutuo acuerdo entre las Partes formalizado de forma expresa
                y por escrito;
              </li>
              <li>
                A la elección de cualquiera de las Partes, sin necesidad de
                justificación alguna, con un preaviso mínimo de diez (10) días;
              </li>
              <li>
                A elección de la Parte no incumplidora, por el incumplimiento
                sustancial por la otra Parte de alguna de las obligaciones
                materiales establecidas en las presentes Condiciones, excepto
                cuando el incumplimiento fuese subsanable y se subsanase dentro
                de los cinco (5) días naturales siguientes a la fecha en que se
                notifique y requiera a la Parte incumplidora para su
                subsanación. Transcurrido dicho plazo sin que el incumplimiento
                se hubiese subsanado, la Parte notificante podrá dar por
                resueltas las presentes Condiciones, mediante su notificación
                por escrito a la Parte incumplidora y reclamarle los daños y
                perjuicios que pudieran;
              </li>
              <li>
                De forma inmediata, en el supuesto en el que Nemuru tenga una
                sospecha o indicio sobre blanqueo de capitales y/o financiación
                del terrorismo o cualquier otra actividad contraria a la
                Legislación Aplicable respecto del Usuario, así como en caso de
                que se produzca una situación relacionada con el Usuario que
                pueda implicar un impacto negativo grave en la reputación e
                imagen de Nemuru o de los Prestamistas; y
              </li>
              <li>
                De forma inmediata, en el supuesto en el que el Usuario no
                acepte los nuevos términos y condiciones de estos T&C
                notificadas por Nemuru de conformidad con lo dispuesto en la
                cláusula 15.9 siguiente.
              </li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Efectos de la finalización o resolución: </strong>
            </h4>
            <span>
              La finalización y/o resolución de estos T&C se dará sin perjuicio
              de los derechos y obligaciones de las Partes que se hayan
              adquirido antes de dicha terminación. En caso de finalización y/o
              rescisión será de aplicación el siguiente régimen:
            </span>
            <ul>
              <li>
                El cese automático de los Servicios y la imposibilidad de
                utilizar la Plataforma y beneficiarse de los Servicios por parte
                del Usuario;
              </li>
              <li>
                El Usuario deberá abonar de forma inmediata a Nemuru cualquier
                cantidad pendiente de pago de forma previa a la resolución de
                estos T&C y, en todo caso, la contraprestación que se hubiese
                abonado de forma previa no será reembolsable y, por lo tanto, el
                Usuario no podrá solicitar el reembolso de la misma; y
              </li>
              <li>
                La finalización o resolución de los presentes T&C no afectará a
                los Contratos de Préstamo formalizados de forma previa ni a
                cualquier otro compromiso asumido por parte del Usuario en el
                marco de la Financiación con el /los Prestamista(s) y sin
                perjuicio de las obligaciones y responsabilidades incurridas, en
                su caso, frente a Nemuru y los Prestamistas en virtud de estos
                T&C; y
              </li>
              <li>
                Las obligaciones, compromisos o pactos de las Partes previstas
                en estos T&C que, por su naturaleza, deban seguir en vigor tras
                la finalización de las mismas, seguirán siendo de aplicación,
                incluyendo, pero sin limitarse a ello, las obligaciones
                (incluidos importes pendientes de pago) asumidas por el Usuario
                en el marco de la Financiación o bajo estos T&C (tanto si la
                misma es asumida con Nemuru o con el Prestamista), o las
                obligaciones o disposiciones previstas en las cláusulas 6.3, ‎7,
                ‎8, ‎9, ‎10, ‎11, ‎12, ‎13, ‎14 y ‎16 de estos T&C.
              </li>
            </ul>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Derechos de Propiedad Intelectual e Industrial</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Derechos de propiedad intelectual e industrial: </strong>
            </h4>
            <span>
              Nemuru será propietaria y conservará todos los derechos, títulos e
              intereses sobre cualquier derecho de propiedad intelectual e
              industrial que ostentase de forma previa a estos T&C o que
              desarrolle durante o tras la vigencia de los mismos, incluyendo
              pero sin limitarse a ello, todos y cada uno de los derechos de
              propiedad industrial y/o intelectual de la Plataforma,
              documentación o materiales asociados a los mismos, incluyendo pero
              sin limitarse a ello a cualquier software y sus algoritmos,
              códigos, procedimientos, ideas o técnicas de cualquier naturaleza,
              incluyendo sus contenidos y la materialización del mismo producto
              o diseño gráfico, texto o imagen desarrollado o creado por
              procedimientos fotográficos, electroestáticos o informáticos,
              patentes, marcas, modelos de utilidad, modelos y dibujos
              industriales, topografías de productos semiconductores y
              cualesquiera otros derechos similares (
              <strong>"PI Nemuru”</strong> o <strong>”PI”</strong>). Salvo lo
              dispuesto en estos T&C, el Usuario no podrá distribuir, vender,
              reproducir, publicar, exhibir, representar, elaborar obras
              derivadas o utilizar de cualquier otro modo la PI Nemuru o de sus
              licenciatarios sin el consentimiento expreso previo por escrito de
              Nemuru.
            </span>
          </li>
          <li>
            Salvo con el permiso expreso y por escrito de Nemuru, el Usuario no
            puede (en todo o en parte) copiar, distribuir, reproducir, adaptar,
            almacenar, transmitir, descifrar, desencriptar, imprimir, mostrar,
            comercializar, ejecutar, publicar o crear obras derivadas, ofrecer a
            la venta o utilizar (salvo lo expresamente autorizado en estos T&C)
            ninguna parte del PI Nemuru. No se concede al Usuario ningún
            derecho, salvo los expresamente establecidos en estos T&C.
          </li>
          <li>
            Asimismo, el Usuario se compromete a no eludir, eliminar, alterar,
            desactivar, degradar o frustrar ninguna de las protecciones del
            contenido de la Plataforma o los Servicios; utilizar cualquier
            robot, spider, scraper u otro medio automatizado para acceder a la
            Plataforma; descompilar, realizar ingeniería inversa o desensamblar
            cualquier software u otros productos o procesos accesibles a través
            de la Plataforma o el Servicio; insertar cualquier código o producto
            o manipular el contenido de la Plataforma o los Servicios de
            cualquier manera; o utilizar cualquier método de minería,
            recopilación o extracción de datos. Además, el Usuario se compromete
            a no cargar, publicar, enviar por correo electrónico o transmitir de
            cualquier otra forma cualquier material diseñado para interrumpir,
            destruir o limitar la funcionalidad de cualquier software o hardware
            informático o equipo de telecomunicaciones asociado a la Plataforma
            o los Servicios, incluyendo cualquier virus o cualquier otro código
            informático, archivos o programas.
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Licencia</strong>
        </h3>
        <ol>
          <li>
            Con sujeción a los presentes T&C, durante la vigencia de estos T&C
            Nemuru concede al Usuario una licencia limitada, revocable, no
            exclusiva, no sublicenciable y no transferible para utilizar la
            Plataforma de Nemuru (la <strong>“Licencia”</strong>), con sujeción
            a los presentes T&C y de conformidad con ellos. Esta Licencia tiene
            como único fin permitirle utilizar la Plataforma y beneficiarse de
            los Servicios de la manera permitida por estos T&C. No se concede al
            Usuario ninguna licencia o derecho, excepto la Licencia y derechos
            que se le conceden expresamente en el marco de estos T&C.
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Manifestaciones y Garantías</strong>
        </h3>
        <ol>
          <li>
            El Usuario manifiesta y garantiza a Nemuru que:
            <ul>
              <li>
                Tiene capacidad legal y capacidad suficiente a los efectos de
                suscribir o aceptar estos T&C, y dar cumplimiento a la totalidad
                de las disposiciones de los mismos;
              </li>
              <li>
                Toda la información, materiales, documentos, contenidos
                facilitados a Nemuru será veraz y legal y no incumplirá ninguna
                disposición legal o derechos de terceros y estarán en todo
                momento actualizados;
              </li>
              <li>
                El Usuario no utilizará los fondos originados bajo la
                Financiación con el fin de financiar cualquier actividad o
                negocio contrario a la Legislación Aplicable en cada momento; y
              </li>
              <li>
                El Usuario reconoce y acepta el derecho de Nemuru a poner fin de
                forma anticipada estos T&C de forma inmediata, siempre que las
                circunstancias manifestadas en esta cláusula varíen o se vean
                alteradas en cualquier forma, y/o Nemuru no pueda garantizar la
                aplicación de la política de sanciones, el cumplimiento de la
                Legislación Aplicable, o incluso el cumplimiento de aquellos
                requisitos recomendados por los distintos organismos nacionales
                o internacionales a los que Nemuru haya decidido vincularse con
                estas finalidades.
              </li>
            </ul>
          </li>
          <li>
            <span>
              En caso de incumplimiento o falta de veracidad de las
              manifestaciones y garantías que se detallan en esta cláusula, se
              aplicará el régimen previsto en la cláusula ‎10 siguiente, todo
              ello sin perjuicio de cualesquiera otros derechos que pudiesen
              ejercer las Partes de conformidad con lo dispuesto en estos T&C o
              en la Legislación Aplicable.
            </span>
            <p>
              Al objeto de que Nemuru pueda cumplir adecuadamente la normativa,
              el Usuario se obliga a respetar, las normas y los procedimientos
              establecidos o que se establezcan en el futuro por ella (Nemuru),
              facilitando cuanta información o documentación resultara exigible
              en aplicación de los mismos (procedimientos y normas).
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Responsabilidad e Incumplimiento</strong>
        </h3>
        <ol>
          <li>
            <span>
              Sin perjuicio de lo dispuesto en la cláusula ‎11 siguiente, cada
              una de las Partes deberá indemnizar y mantener indemne a la otra
              Parte por cualesquiera daños y perjuicios que pudieran sufrir como
              consecuencia de (i) cualquier incumplimiento de sus respectivas
              obligaciones previstas en estos T&C; y (ii) cualquier
              incumplimiento o falta de veracidad o inexactitud de las
              manifestaciones y garantías realizadas de conformidad con la
              cláusula anterior.
            </span>
            <p>
              Lo dispuesto en el apartado anterior será sin perjuicio de
              cualquier otro derecho o consecuencia prevista en los presentes
              T&C, y del derecho de la Parte cumplidora a resolver estos T&C de
              conformidad con lo previsto en los mismos.
            </p>
            <p>
              La responsabilidad de cualquiera de las Partes por cualquier
              incumplimiento de estos T&C dará lugar al derecho de la otra Parte
              a reclamar los daños y perjuicios que se hubieren producido y
              exigir en todo caso el cumplimiento de estos T&C.
            </p>
          </li>
          <li>
            <span>
              Por último, Nemuru se reserva el derecho exclusivo de defender
              directamente o a través de un tercero, cualquier reclamación,
              demanda o procedimiento de cualquier tipo, bajo el cual Nemuru
              pueda llegar a tener derecho cualquier tipo de indemnización de
              conformidad con los presentes T&C, sin que ello limite o restrinja
              la responsabilidad del Usuario. En este caso, el Usuario deberá
              facilitar a Nemuru o a cualquier tercero designado por Nemuru a
              tal efecto, incluyendo el Prestamista, toda aquella documentación
              que razonablemente sea necesaria a los efectos de llevar a cabo
              las actuaciones anteriores, así como colaborar con Nemuru y con
              cualquier tercero designado a tal efecto por Nemuru, incluyendo el
              Prestamista, en términos razonables.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Exención o Limitación de Responsabilidad</strong>
        </h3>
        <ol>
          <li>
            <span>
              Las Partes reconocen y aceptan que Nemuru no asume ningún tipo de
              responsabilidad y/u obligación derivada de la Financiación y/o de
              cualquier otro aspecto o incidencia que se pueda dar en el marco
              de la concesión de la Financiación, ni derivada de la compra del
              producto o prestación del servicio del Comercio financiado por el
              Prestamista al Usuario.
            </span>
            <p>
              En línea con lo dispuesto en el párrafo anterior, ni Nemuru ni
              ninguna otra entidad de su grupo de sociedades será en ningún caso
              responsable del proceso, la información, el desembolso de la
              Financiación, la documentación, el contenido entre otros, de las
              pantallas y avisos legales o textos legales del Prestamista o del
              Comercio o referidos a la Financiación, la compraventa de los
              productos o contratación de los servicios financiados, cualquier o
              cualquier otro incumplimiento de la Legislación Aplicable por
              parte del Prestamista y/o el Comercio. Asimismo, Nemuru no se hará
              cargo de la custodia de las credenciales de banca online del
              Usuario, cediendo dicha información a un proveedor de información
              de cuentas de pago, quien será el encargado de custodiar y
              proteger dicha información. A tal efecto, únicamente conservarán
              las credenciales de la banca online tokenizadas, sin conservarse,
              en ningún caso, la información relativa a la tarjeta de crédito o
              número de cuenta bancaria.
            </p>
          </li>
          <li>
            <span>
              Adicionalmente a lo dispuesto en la cláusula anterior, los
              Servicios, la Plataforma de Nemuru y toda la información,
              productos y servicios proporcionados a través de la Plataforma de
              Nemuru se proporcionan "tal cual" “as is” y "según disponibilidad"
              “as available”, y Nemuru no garantiza que la Plataforma de Nemuru
              o los Servicios sean seguros, ininterrumpidos, precisos o libres
              de errores, o que su información esté segura y, a tal efecto, el
              Usuario renuncia de forma expresa a todas las garantías expresas o
              implícitas de todo tipo, incluyendo, pero sin limitarse a ello,
              garantías implícitas de exactitud o fiabilidad, validez,
              disponibilidad, idoneidad o integridad de cualquier información,
              contenido o datos proporcionados a través de la Plataforma de
              Nemuru y, por tanto, en ningún caso, Nemuru será responsable por
              cualquier reclamación, pérdida, daño, responsabilidad, coste o
              gasto de cualquier tipo, ya sea directo o indirecto (incluidos los
              daños por lucro cesante, pérdida de ingresos, beneficios, datos,
              uso, fondo de comercio u otras pérdidas intangibles,
              reputacionales) o cualquier otro daño de cualquier tipo
              relacionado con o causado por el acceso o el uso de la Plataforma
              de Nemuru o los Servicios.
            </span>
          </li>
          <li>
            <span>
              Por último, en la máxima medida permitida por la Legislación
              Aplicable: (a) ni Nemuru ni ninguna entidad de su grupo de
              sociedades serán en ningún caso responsables de los daños de
              cualquier tipo, que se deriven de cualquier modo del uso o la
              incapacidad de usar los Servicios o la Plataforma de Nemuru su
              contenido o los materiales, incluyendo, sin limitación alguna, los
              daños que ocasione o se deriven de la utilización, por parte del
              Usuario, de cualquier información o material obtenido a través de
              la Plataforma de Nemuru, o que sean consecuencia de errores,
              omisiones, interrupciones, eliminaciones de archivos o mensajes de
              correo electrónico, errores, defectos, virus, retrasos en el
              funcionamiento o transmisión o cualquier fallo de rendimiento, sea
              resultante o no de hechos fortuitos, fallos en las comunicaciones,
              robos o destrucción o acceso no autorizado a los registros,
              programas o servicios de Nemuru; y (b) la responsabilidad total de
              Nemuru, ya sea contractual, extracontractual o por garantía
              (incluido por negligencia), responsabilidad por productos
              defectuosos, responsabilidad objetiva o responsabilidad derivada
              de cualquier otro principio jurídico, en relación con el uso o la
              incapacidad de usar los Servicios o la Plataforma de Nemuru, no
              excederá en ningún caso del importe que haya abonado el Usuario en
              el marco del Servicio que ha generado el daño o perjuicio, en su
              caso. En la medida en que la Legislación Aplicable impida la
              limitación de tal responsabilidad, Nemuru limitará su
              responsabilidad en todo lo permitido por la Legislación Aplicable.
            </span>
          </li>
          <li>
            <span>
              Las previsiones dispuestas en la presente cláusula seguirán en
              vigor tras la finalización o resolución de las presentes
              Condiciones.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Protección de Datos</strong>
        </h3>
        <ol>
          <li>
            <span>
              El tratamiento de los datos del Usuario se regirá de conformidad
              con la Política de Privacidad, donde se describen las prácticas de
              información, incluyendo los tipos de información que Nemuru recibe
              y recopila por y del Usuario, así como el detalle de cómo se
              utiliza y se comparte esta información, y los derechos del Usuario
              en relación con el tratamiento de la información sobre el Usuario.
              La Política de Privacidad establece las bases legales para el
              procesamiento de la información personal sobre el Usuario,
              incluyendo, entre otros, la recopilación, uso, procesamiento y
              distribución de dicha información, así como la transferencia y
              procesamiento de dicha información donde tengamos o utilicemos
              instalaciones, proveedores de servicios, empresas afiliadas o
              socios, independientemente de donde el Usuario acceda a la
              Plataforma.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Confidencialidad</strong>
        </h3>
        <ol>
          <li>
            <h4>Confidencialidad: </h4>
            <span>
              El Usuario se compromete a: (a) proteger y no divulgar la
              información puesta a disposición por Nemuru que esté identificada
              como confidencial o que razonablemente deba considerarse
              confidencial; (b) utilizar esta información sólo para cumplir con
              sus obligaciones en virtud de estos T&C; (c) no eliminar ningún
              aviso o marca de derechos de autor, aviso de marca registrada y/o
              cualquier otra leyenda de propiedad establecida o contenida en
              cualquiera de la información confidencial; y (d) destruir o
              devolver a Nemuru toda esa información con prontitud cuando estos
              T&C terminen (y, a petición de Nemuru, confirmar dicha destrucción
              por escrito). Esta cláusula abarca toda la información
              confidencial, independientemente del momento en que el Usuario la
              reciba.
            </span>
            <p>
              Las obligaciones asumidas en virtud de esta cláusula seguirán
              siendo plenamente vigentes tras la finalización o resolución de
              los presentes T&C, mientras la información confidencial sea
              secreta y confidencial.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Notificaciones</strong>
        </h3>
        <ol>
          <li>
            <span>
              Todos los avisos, notificaciones, consentimientos y otras
              comunicaciones requeridas o permitidas en virtud de estos T&C se
              harán por escrito y en español, y de forma fehaciente (aportando
              pruebas de su recepción y lectura). En particular, todos los
              avisos, notificaciones, consentimientos y otras comunicaciones se
              enviarán a la siguiente dirección:
            </span>
            <div style={{ paddingTop: "8px" }}>
              <strong>Nemuru: </strong>
              <div>A la atención de: Soporte Nemuru</div>
              <div>
                Dirección: Edificio Palau de Mar, Plaza Pau Vila, número 1, 1ª
                planta, sector AD, oficina 1AD, Barcelona
              </div>
              <div>E-mail: hola@nemuru.com</div>
              <div>Teléfono: +34 932 200 612</div>
            </div>
            <div style={{ paddingTop: "8px" }}>
              <strong>Usuario: </strong>
              email y/o dirección postal facilitada por el Usuario en el proceso
              de registro en la Plataforma. Se considerará que el Usuario ha
              recibido todas las comunicaciones enviadas a estas direcciones,
              incluso si la misma ya no fuese la vigente.
            </div>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Miscelánea</strong>
        </h3>
        <ol>
          <li>
            <h4>Póliza de Seguro de Responsabilidad Civil Profesional: </h4>
            <span>
              Nemuru es titular de la póliza de seguro de responsabilidad civil
              profesional PI-61693020M0, contratada a través de la agencia de
              suscripción Dual Ibérica Riesgos Profesionales S.A.U. por cuenta
              de Liberty Mutual Insurance Europe SE y Lloyd’s Insurance Company
              S.A.
            </span>
          </li>
          <li>
            <h4>Calidad y Códigos Éticos: </h4>
            <span>
              Nemuru es una entidad que se encuentra adherida a Confianza Online
              (Asociación sin ánimo de lucro), inscrita en el Registro Nacional
              de Asociaciones Grupo 1, Sección 1, número nacional 594400, CIF
              G85804011, Calle la Palma 59, Bajo A., 28015 Madrid (España). Para
              más información: (www.confianzaonline.es).
            </span>
            <p>
              Estos T&C se rigen por la legislación española. Así mismo, en
              cumplimiento de lo dispuesto en la Ley de Resolución Alternativa
              de Litigios, informamos a los consumidores que, como entidad
              adherida y en los términos del Código Éticos, los usuarios podrán
              acudir a Confianza Online para la resolución alternativa de
              eventuales controversias Formulario de Reclamaciones.
            </p>
            <p>
              Si éstas se refieren a transacciones electrónicas con
              consumidores, o sobre protección de datos cuando estén
              relacionadas con este ámbito, las reclamaciones serán resueltas
              por el Comité de Mediación de Confianza Online, acreditado para la
              resolución alternativa de litigios en materia de consumo. Si las
              reclamaciones versan sobre publicidad digital, o sobre protección
              de datos relacionada con este ámbito, serán sometidas al Jurado de
              la Publicidad de AUTOCONTROL.
            </p>
            <p>
              Además, se le recuerda al Usuario que puede acceder a la
              plataforma de resolución de litigios en línea de la Unión Europea
              siguiendo este enlace:{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank">
                Plataforma Resolución de litigios de la Unión Europea
              </a>
            </p>
          </li>
          <li>
            <h4>Data access: </h4>
            <span>
              El Usuario autoriza y acepta que Nemuru se conecte o acceda
              directamente o a través de cualquier tercero designado por Nemuru
              a los datos que se deriven de los Servicios, a los efectos de
              recabar, agregar, compilar y utilizar dichos datos, de la forma
              que Nemuru considere oportuna, incluyendo iniciativas de calidad,
              la evaluación comparativa, los servicios de información o la
              mejora de los Servicios, entre otros. Los datos recogidos o
              recabados por Nemuru se utilizarán, durante y después de la
              resolución o finalización de estos T&C, manteniendo siempre el
              mismo nivel de confidencialidad respecto al Usuario.
            </span>
          </li>
          <li>
            <h4>Subcontratación: </h4>
            <span>
              Nemuru podrá subcontratar cualquier trabajo o Servicio a llevar a
              cabo en el marco del presente documento. En todo caso, Nemuru
              seguirá estando obligada al cumplimiento debido y puntual de
              cualquier obligación subcontratada en el marco del presente
              documento.
            </span>
          </li>
          <li>
            <h4>Epígrafes, títulos y separabilidad: </h4>
            <span>
              Los epígrafes y títulos del presente documento se han incluido a
              los únicos efectos de facilitar su lectura y no pretenden en modo
              alguno describir el contenido de las correspondientes Cláusulas ni
              representar compromisos, términos o condiciones del presente
              documento.
            </span>
            <p>
              Si se determina que alguna disposición del presente documento es
              inválida o inaplicable en su totalidad o en parte, por cualquier
              motivo presente o futuro, dicha invalidez o inaplicabilidad no
              afectará a la aplicabilidad de ninguna de las disposiciones
              restantes del mismo. El presente documento se interpretará como si
              dichas disposiciones inválidas o inaplicables nunca hubieran
              estado contenidas en el mismo. A estos efectos, el documento
              dejará de ser válido exclusivamente con respecto a la disposición
              nula o inválida, y ninguna de las restantes partes o disposiciones
              del presente documento será nula, inválida, perjudicada o afectada
              por dicha nulidad o invalidez, salvo que por resultar esencial
              para los Servicios tuviera que afectar al presente documento en su
              conjunto.
            </p>
          </li>
          <li>
            <h4>Acuerdo Íntegro: </h4>
            <span>
              Este documento y sus anexos, si los hubiera, constituyen el
              acuerdo íntegro entre las Partes en relación con el objeto del
              mismo y sustituye a cualesquiera otros pactos o acuerdos previos,
              escritos o verbales, existentes entre las Partes que versen sobre
              dicha materia.
            </span>
          </li>
          <li>
            <h4>Renuncia de acciones: </h4>
            <span>
              La renuncia o el no ejercicio de los derechos de cualquiera de las
              Partes en virtud del presente documento no se considerará una
              renuncia o limitación de cualquier otro derecho o de cualquier
              derecho futuro. Toda renuncia debe hacerse por escrito y ser
              aceptada expresamente por la Parte a la que se le imputa.
            </span>
          </li>
          <li>
            <h4>Cesión: </h4>
            <span>
              El Usuario no podrá ceder o transferir sus derechos u obligaciones
              en virtud de este documento, en su totalidad o en parte, a ningún
              tercero sin el previo consentimiento expreso y por escrito de
              Nemuru. Nemuru podrá ceder sus derechos y obligaciones en virtud
              del presente documento sin necesidad de obtener el consentimiento
              del Usuario.
            </span>
          </li>
          <li>
            <h4>Modificaciones: </h4>
            <span>
              Nemuru puede modificar, añadir o eliminar este documento y el
              contenido de la Plataforma en cualquier momento y a su entera y
              libre discreción. En todo caso, Nemuru notificará antes de
              cualquier cambio de estos T&C cuando sigan siendo de aplicación a
              los Usuarios. Si el Usuario no está de acuerdo con las nuevas
              condiciones, deberá interrumpir el acceso y el uso de la
              Plataforma y los Servicios. Su uso y acceso a la Plataforma y/o a
              los Servicios tras cualquier modificación de este acuerdo se
              considerará una aceptación tácita o implícita de todas las
              modificaciones.
            </span>
          </li>
          <li>
            <h4>Fuerza Mayor: </h4>
            <span>
              Ninguna de las Partes será responsable de cualquier fallo o
              retraso en el cumplimiento de sus obligaciones en virtud de este
              documento por cualquier causa más allá del control razonable de
              dicha Parte, incluyendo, pero sin limitarse a ello, los cortes
              eléctricos, el fallo de los proveedores de servicios de Internet,
              el incumplimiento debido a la interrupción de Internet
              (incluyendo, sin limitación, los ataques de denegación de
              servicio), los disturbios, la insurrección, los actos de
              terrorismo, la guerra (o similares), los incendios, las
              inundaciones, las pandemias, los terremotos, las explosiones y
              otros actos fuera del control de las Partes.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Ley y Jurisdicción Aplicables</strong>
        </h3>
        <ol>
          <li>
            <span>
              Estos T&C y el acceso y uso de la Plataforma y de los Servicios se
              regirán de forma exclusive por la legislación española, excluyendo
              de forma expresa la aplicación de cualquier otra norma o
              legislación que pudiese llegar a ser de aplicación.{" "}
            </span>
          </li>
          <li>
            <span>
              Cualquier disputa, controversia, conflicto o reclamación que
              pudiera derivarse de la interpretación o ejecución de estos T&C
              (incluyendo la Política de Privacidad y la Política de Cookies), o
              relacionados de forma directa o indirecta con la utilización de la
              Plataforma o la prestación de los Servicios, deberá someterse de
              forma exclusiva a los Juzgados y Tribunales de la Ciudad de
              Barcelona (España).
            </span>
          </li>
        </ol>
      </li>
    </ol>
  </div>
);
